export default __webpack_public_path__ + "static/media/Marisa-Hall.9dd310ec.jpg";